var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divide-y divide-gray-200"},[_c('div',[_c('apexchart',{ref:"chart",attrs:{"width":"100%","height":"240","type":"area","options":_vm.options,"series":_vm.series}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }